// @flow
const MESSAGE = 'Not Found'

// HACK (jake): workaround for https://stackoverflow.com/a/33877501/393075
export default class NotFoundError extends Error {
  static isNotFoundError = (error: any) => {
    return error instanceof Error && error.message === MESSAGE
  }

  constructor() {
    super(MESSAGE)
  }
}
